"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
TripsListController.$inject = ['$scope', '_trip', '$state', 'notify', '$q'];
function TripsListController($scope, _trip, $state, notify, $q) {
    var self = this;
    $scope.total = 0;
    $scope.last_params = _trip.getLastParams();
    function refresh(params) {
        _trip.fetch(params).then(function (items) {
            $scope.last_params = _trip.getLastParams();
            $scope.trips = items;
            $scope.total = items.total;
            $scope.loading = false;
        }, function (err) {
            console.log(err);
        });
    }
    $scope.$on('refreshList', function (e, params) {
        $scope.loading = true;
        refresh(params[0]);
    });
    $scope.newTrip = function () {
        $state.go('trips_edit');
    };
    $scope.edit = function (id) {
        $state.go('trips_edit', { id: id });
    };
    $scope.locateShip = function (trip) {
        _trip.locateShip(trip);
    };
    $scope.remove = function (id) {
        _trip.remove(id).then(function (response) {
            notify.success('You have successfully deleted the trip.');
            refresh();
        }, function (error) {
            console.log(error);
        });
    };
}
exports.TripsListController = TripsListController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/controllers/TripsListController.ts
// module id = 562
// module chunks = 0